import { Typography } from "@mui/material";

import DataNotAvailable from "../../../../ui library/icons/DataNotFound";
import { STRINGS } from "../config/strings";
import { useProviderSearchStore } from "../store/providerSearchStore";

import OutlinedButton from "./Buttons/OutlinedButton";

export default function DataNotFoundContainer() {
  const {
    inNetwork,
    maxDistance,
    setInNetwork,
    showCustomSearch,
    customAddressSearchText,
    disableOONButton,
  } = useProviderSearchStore();
  const onClickOutOfNetworkProvidersBtn = () => {
    if (!showCustomSearch || customAddressSearchText) {
      setInNetwork(-1);
    }
  };

  return (
    <div className="absolute bottom-0 left-0 right-0 top-0 flex flex-col items-center justify-center gap-2 rounded-lg bg-sky-100 px-2 py-4">
      <DataNotAvailable />
      <div className="flex flex-col gap-1">
        <Typography className="text-center text-xl text-blue-700">
          <span className="font-semibold">
            {customAddressSearchText ? STRINGS.NO_RESULT_FOUND : STRINGS.ENTER_ADDRESS}
          </span>
        </Typography>

        <Typography className="px-10 text-center">
          {customAddressSearchText
            ? `${inNetwork ? "There are no In Network Providers found within " + maxDistance + " miles" : ""}`
            : `Please provide your client's address so we may find the most conveniently located in-network provider.`}
        </Typography>
      </div>

      {/* Note: Keeping this field hidden as per the current requirement. However, if in future its is required, just remove hidden and add an option in NETWORK_OPTS*/}
      <div className="mb-4 hidden w-1/2">
        <OutlinedButton
          disabled={disableOONButton}
          onClick={onClickOutOfNetworkProvidersBtn}
          label={STRINGS.BUTTON_LABELS.INCLUDE_OON}
        />
      </div>
    </div>
  );
}
